import { ref, firebaseAuth, googleProvider, facebookProvider } from '../config/constants'
import { risks, users } from '../config/data'
const today = new Date()

export function auth(email, pw) {
  return firebaseAuth().createUserWithEmailAndPassword(email, pw)
    .then(saveUser)
}

export function logout() {
  return firebaseAuth().signOut()
}

export function login(email, pw) {
  return firebaseAuth().signInWithEmailAndPassword(email, pw)
}

export function resetPassword(email) {
  return firebaseAuth().sendPasswordResetEmail(email)
}

export function googleLogin() {
  return firebaseAuth().signInWithPopup(googleProvider)
}

export function facebookLogin() {
  return firebaseAuth().signInWithPopup(facebookProvider)
}

export function saveUser(user) {
  return ref.child(`users/${user.uid}`)
    .set({
      info: {
        email: user.email,
        uid: user.uid
      },
      session: {
        risks: {},
        users: {}
      }
    })
    .then(() => {
      const userRef = ref.child(`users/${user.uid}/session/users`)
      return Promise.all(users.map(user => new Promise((res, rej) => {
        const newUser = userRef.push()
        newUser.set(user)
          .then(() => res(newUser.key))
          .catch(err => rej(err))
      })))
    })
    .then(userKeys => {
      const riskRef = ref.child(`users/${user.uid}/session/risks`)
      return Promise.all(risks.map(risk => new Promise((res, rej) => {
        const newRisk = riskRef.push()
        newRisk.set({
          ...risk,
          created: new Date().setDate(today.getDate() - risk.created),
          owner: userKeys[risk.owner]
        })
          .then(() => res())
          .catch(err => rej(err))
      })))
    })
    .then(() => user)
}



// WEBPACK FOOTER //
// ./src/helpers/auth.js